import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceNameEntry } from '@features/eor/WorkspaceNameEntry';

export const Route = createFileRoute('/eor/workspace')({
  component: WorkspaceNameEntry,
});
